import { useState } from "react";
import './AddressForm.css';

export default function AddressForm({ onSubmit, onCancel }) {
    const [street, setStreet] = useState('');
    const [city, setCity] = useState('');
    const [state, setState] = useState('');
    const [zip, setZip] = useState('');
    const [error, setError] = useState('');

    const stateAbbreviations = [
        "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA", "HI", "ID", "IL", "IN", "IA", "KS", 
        "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM", "NY", 
        "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA", 
        "WV", "WI", "WY"
    ];

    const handleSubmit = (e) => {
        e.preventDefault();
        
        // Validate Zip Code (5-digit or 9-digit format)
        const zipRegex = /^\d{5}(-\d{4})?$/;
        if (!zipRegex.test(zip)) {
            setError("Please enter a valid 5-digit or 9-digit zip code.");
            return;
        }

        // Clear any previous error messages
        setError('');

        // Trim values to avoid extra spaces
        const newAddress = { 
            street: street.trim(), 
            city: city.trim(), 
            state, 
            zip: zip.trim() 
        };

        // Call the parent onSubmit function and pass the address data
        onSubmit(newAddress);
    };

    return (
        <div className="addressForm">
            <form onSubmit={handleSubmit}>
                <label htmlFor="street">Street</label>
                <input 
                    type="text"
                    id="street"
                    name="street"
                    placeholder="Street"
                    value={street}
                    onChange={(e) => setStreet(e.target.value)}
                    required
                />
                
                <label htmlFor="city">City</label>
                <input 
                    type="text"
                    id="city"
                    name="city"
                    placeholder="City"
                    value={city}
                    onChange={(e) => setCity(e.target.value)}
                    required
                />

                <label htmlFor="state">State</label>
                <select 
                    id="state"
                    name="state" 
                    value={state} 
                    onChange={(e) => setState(e.target.value)} 
                    required
                >
                    <option value="" disabled>-- Select State --</option>
                    {stateAbbreviations.map((abbr) => (
                        <option key={abbr} value={abbr}>
                            {abbr}
                        </option>
                    ))}
                </select>

                <label htmlFor="zip">Zip Code</label>
                <input 
                    type="text"
                    id="zip"
                    name="zip"
                    placeholder="Zip Code"
                    value={zip}
                    onChange={(e) => setZip(e.target.value)}
                    required
                />
                
                {/* Show error message if zip code is invalid */}
                {error && <p className="error">{error}</p>}

                <div className="button-group">
                    <button 
                        type="submit" 
                        style={{ backgroundColor: 'dodgerblue' }}
                        disabled={!street || !city || !state || !zip} // Disable if incomplete
                    >
                        Submit Address
                    </button>
                    
                    {/* Cancel button to close the form */}
                    {onCancel && (
                        <button 
                            type="button" 
                            className="cancel-button"
                            onClick={onCancel}
                        >
                            Cancel
                        </button>
                    )}
                </div>
            </form>
        </div>
    );
}
